import { ITelegramAccountRepository } from '../../ports/ITelegramAccountRepository';
import { TelegramAccountBrandingEntity } from '../../../domain/entities/TelegramAccountBranding';
import { UpdateTelegramAccountBrandingInput } from '../../../shared/types/TelegramAccountBranding';

export class UpdateTelegramAccountBrandingUseCase {
  constructor(private repo: ITelegramAccountRepository) {}
  async execute(uuid: string, input: UpdateTelegramAccountBrandingInput): Promise<TelegramAccountBrandingEntity> {
    return this.repo.updateBranding(uuid, input);
  }
}
